import HttpService from './httpService';
import config from '../../config';

class PresupuestosApiService extends HttpService {
  async buscarPresupuestos(filters) {
    return this.get('presupuestos', {
      params: {
        headquarter: filters.headquarter === 'CEDETECGROUP' ? 'TODAS' : filters.headquarter,
        id: filters.idPresupuesto || undefined,
        nombre: filters.nombre || undefined,
        apellidos: filters.apellidos || undefined,
        dni: filters.dni || undefined,
        correo: filters.email || undefined,
        estado: filters.estado || undefined,
      },
    });
  }

  async listarContactosHubspot({ limit = 100, after } = {}) {
    return this.get('hubspot/contactos', {
      params: {
        limit,
        after: after || undefined,
      },
    });
  }

  async importarContactosHubspot({ headquarter, contactos }) {
    return this.post('hubspot/importar', { headquarter, contactos });
  }

  async crearPresupuesto(data) {
    return this.post('presupuestos', data);
  }

  async enviarPresupuesto({ headquarter, id }) {
    return this.post('presupuesto/enviar', { headquarter, id });
  }

  async generarPresupuestoPDF({ headquarter, id, mostrarPrecios = false }) {
    return this.get('presupuesto/pdf', {
      params: { headquarter, id, mostrarPrecios },
      responseType: 'blob',
    });
  }

  // PDF de secretaría con 1er y 2º año. Solo admin: el backend responde 403
  // (verifyAdminOnly) para el resto de roles. Exige la sede en mayúsculas.
  async generarPresupuestoPdfInterno({ headquarter, id }) {
    return this.get('presupuesto/pdf-interno', {
      params: { headquarter: (headquarter || '').toUpperCase(), id },
      responseType: 'blob',
    });
  }

  // Módulos de un grupo desde gruposl, sin contexto de alumno (modo
  // `codegroups` de buscarModulos: con el param presente aunque vacío, el
  // backend devuelve el catálogo completo del grupo). Se usa para añadir
  // módulos del 2º año a una propuesta.
  async buscarModulosGrupo({ headquarter, groupId }) {
    return this.get('buscarModulos', {
      params: { headquarter, groupId, codegroups: '' },
    });
  }

  async obtenerPresupuesto({ headquarter, id }) {
    return this.get('presupuesto', { params: { headquarter, id } });
  }

  async actualizarPresupuesto(data) {
    return this.put('presupuesto', data);
  }

  async crearLead(data, { headquarter }) {
    return this.post('leads', data, { params: { headquarter } });
  }

  async buscarLeads(filters) {
    return this.get('leads', {
      params: {
        centro: filters.centro === 'CEDETECGROUP' ? 'TODOS' : filters.centro,
        id: filters.id || undefined,
        ccodcli: filters.ccodcli || undefined,
        nombre: filters.nombre || undefined,
        apellidos: filters.apellidos || undefined,
        dni: filters.dni || undefined,
        email: filters.email || undefined,
      },
    });
  }

  async listarPlanesPago({ headquarter, presu_id: presuId }) {
    return this.get('presupuesto/pagos', {
      params: { headquarter, presu_id: presuId },
    });
  }

  async crearPlanPago(plan) {
    // plan: { headquarter, presu_id, Cuotas, Fecha_ini, Fecha_fin, tipo }
    return this.post('presupuesto/pagos', plan);
  }

  async actualizarPlanPago(plan) {
    // plan: { headquarter, Id, Cuotas?, Fecha_ini?, Fecha_fin?, tipo? }
    return this.put('presupuesto/pagos', plan);
  }

  async borrarPlanPago({ headquarter, Id }) {
    return this.delete('presupuesto/pagos', { data: { headquarter, Id } });
  }
}

const presupuestosApiService = new PresupuestosApiService(config.REACT_APP_NODE_API);
export default presupuestosApiService;
